import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export type {
  BitcoinNetwork,
  DynamicWalletClient,
  ThresholdSignatureScheme
} from '@dynamic-labs-wallet/browser-wallet-client';
export { DYNAMIC_WAAS_METADATA } from '../modules/waas/constants';
export { createWaasClient } from '../modules/waas/createWaasClient';
export { createWaasProvider } from '../modules/waas/createWaasProvider';
export { getAllUserWaasAddressesForChain } from '../modules/waas/getAllUserWaasAddressesForChain';
export { getWaasChainNameFromChain } from '../modules/waas/getWaasChainNameFromChain';
export type {
  WaasProvider,
  WaasWalletProvider
} from '../modules/waas/waas.types';

